import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import _ from 'lodash';

import * as actions from '../redux/actions';
import PersonPictograph from "../charts/PersonPictograph";
import NationalSelector from "../charts/NationalSelector";

import ageIcon from '../images/icon-age.svg';
import pillIcon from '../images/icon-pill.svg';
import hospitalIcon from '../images/icon-hospital.svg';

import './StateDetailCard.css';

const maRateProp = 'BDC3';
const pctMaleProp = 'BDC6';
const pctFemaleProp = 'BDC5';
const avgAgeProp = 'BDC4';
const avgHccProp = 'BDC12';
const mcAvgProp = 'BDC11';


class StateDetailCard extends Component {
  render() {
    const year = this.props.year;
    const yearIndex = 2015 - (year || 2015);
    const getDataValue = prop => {
      return _.get(this.props.data, [prop, yearIndex], 0);
    };

    return (
      <div className="StateDetailCard">
        <Card noHovering={true}>
          <Row gutter={20}>
            {!this.props.hideSelector &&
            <Col xs={24} md={6}>
              <NationalSelector
                maxHeight={200}
                dict={this.props.stateDict}
                selectedState={this.props.selectedState.fips}
                onClick={this.props.actions.selectState}
              />
            </Col>
            }
            <Col xs={24} md={18}>
              <Row gutter={this.props.hideSelector ? 4 : 28}>
                <h1 className="title">
                  {this.props.selectedState.name} State Health Dimensions
                </h1>
                <Col xs={24} sm={8}>
                  <PersonPictograph
                    className="red"
                    value={getDataValue(maRateProp)}
                    personCount={10}
                    total={100}
                    label={`MA Participation Rate ${this.props.year}\n`}
                    description={'State Percent of Part A and Part B beneficiaries who are in enrolled in a MA program'}
                  />
                </Col>
                <Col xs={12} sm={8}>
                  <PersonPictograph
                    className="blue"
                    value={getDataValue(pctMaleProp)}
                    personCount={10}
                    total={100}
                    label={`Percent Male ${this.props.year}\n`}
                    description={'State Percent of Medicare fee-for-service beneficiaries who are male'}
                  />
                </Col>
                <Col xs={12} sm={8}>
                  <PersonPictograph
                    className="pink"
                    value={getDataValue(pctFemaleProp)}
                    personCount={10}
                    total={100}
                    label={`Percent Female ${this.props.year}\n`}
                    description={'State Percent of Medicare fee-for-service beneficiaries who are female'}/>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Row gutter={18}>
          <Col xs={24} md={8}>
            <Card className="kpi" noHovering={true}>
              <img src={ageIcon} alt="age icon"/>
              <h2 className="subtitle">
                State Average age of Medicare fee-for-service beneficiaries {this.props.year}
              </h2>
              <h1 className="title">
                {getDataValue(avgAgeProp)} Years Old
              </h1>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card className="kpi" noHovering={true}>
              <img src={pillIcon} alt="health icon"/>
              <h2 className="subtitle">
                State Average Hierarchical Condition Category (HCC) Score {this.props.year}
              </h2>
              <h1 className="title">
                {getDataValue(avgHccProp)} Risk Score
              </h1>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card className="kpi" noHovering={true}>
              <img src={hospitalIcon} alt="hospital icon"/>
              <h2 className="subtitle">
                State Medicare FFS beneficiaries who are eligible for Medicaid {this.props.year}
              </h2>
              <h1 className="title">
                {getDataValue(mcAvgProp)} Percent
              </h1>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStoreToProps(store, props) {
  const stateFips = _.get(store, ['states', 'selected', 'fips']);
  const stateData = _.get(store, ['states', 'dict', stateFips], {});
  const statePerc = _.get(store, ['states', 'percentileDict', stateFips], {});

  return {
    loading: store.states.loading || store.dimensions.loading,
    year: store.dimensions.year,
    selectedState: store.states.selected,
    data: stateData,
    stateDict: store.states.dict,
    percentiles: statePerc,
    hideSelector: props.hideSelector
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(StateDetailCard);



// WEBPACK FOOTER //
// ./src/containers/StateDetailCard.js